import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { ActionComponent } from '../../../ui/api/action.component';
@Component({
    selector: 'product-wishlist-toggle',
    templateUrl: 'product-wishlist-toggle.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ActionComponent]
})
export class ProductWishlistToggleComponent extends WishlistToggleComponentDef {
    @Input()
    small = false;
}
